<script lang="ts" setup>
import { computed } from 'vue';
import { useClaims } from '@auth/useClaims';
import { environmentName, showBanner } from '@environment/environment';
import VChip, { type VChipProps } from '@shared/component/VChip/VChip.vue';
import SBLogo from '@assets/icons/SBLogo.vue';
import SPLogo from '@assets/icons/SPLogo.vue';
import SUREbusinessLogo from '@assets/icons/SUREbusinessLogo.vue';
import SUREprivateLogo from '@assets/icons/SUREprivateLogo.vue';
import BrandingLogo from './BrandingLogo.vue';

const claims = useClaims();

const bannerColor = computed<VChipProps['color']>(() => {
  if (environmentName === 'test') return 'red';
  if (environmentName === 'acceptatie') return 'blue';
  return 'orange';
});
</script>

<template>
  <component
    class="p-2"
    :class="{
      'grid grow': !claims?.isTemporaryUser,
    }"
    v-bind="{
      ...(!claims?.isTemporaryUser && {
        href: '/app/aanvraag/recente-activiteiten/',
      }),
    }"
    :is="claims?.isTemporaryUser ? 'div' : 'a'"
  >
    <div class="relative flex h-full items-center justify-center">
      <template v-if="!claims?.isTemporaryUser">
        <!-- SPLogo hangt te laag: de 'p'-staart valt buiten de viewBox, dus omhoog nudgen. TODO: SVG zelf fixen -->
        <component
          :is="claims?.isParticulier ? SPLogo : SBLogo"
          class="h-6 3xl:hidden"
          :class="claims?.isParticulier && '-translate-y-1'"
        />

        <component
          :is="claims?.isParticulier ? SUREprivateLogo : SUREbusinessLogo"
          class="h-6 -translate-y-[5px] max-3xl:hidden"
        />
      </template>

      <BrandingLogo v-else />

      <VChip
        v-if="showBanner"
        class="absolute -right-3 top-0 rotate-12 capitalize"
        :color="bannerColor"
        :label="environmentName"
        size="sm"
      />
    </div>
  </component>
</template>
